import React, { Fragment } from "react";
import { useState } from "react";
import classNames from "classnames";
import moment from "moment-timezone";
import { FormattedNumber } from "react-intl";

const ChallengeSectionRow = ({ currency_code, challenge_table, timezone, challenge }) => {
  const [isActive, setIsActive] = useState(false);
  const currentHour = moment().tz(timezone).format("MMMM Do YYYY, h A");

  return (
    <Fragment>
      <div
        onClick={() => setIsActive(!isActive)}
        className={classNames("challenge-row", {
          now:
            challenge_table.time_type === "Hourly" &&
            currentHour ===
              moment(challenge.start_hour).tz(timezone).format("MMMM Do YYYY, h A"),
        })}>
        <div className="challenge-item">
          {challenge_table.time_type === "Hourly" && (
            <span className="item">
              {moment(challenge.start_hour).tz(timezone).format("h:mm a")}
            </span>
          )}
          <span className="item name" title={challenge.name}>
            {challenge.name}
          </span>
          <span className="item dollars">
            <FormattedNumber
              value={challenge.prize}
              style="currency"
              currencyDisplay="symbol"
              currency={currency_code}
            />
          </span>
          <span className="item winner">{challenge.winner}</span>
          <div className="challenge-icon">
            {isActive ? (
              <i className="fa fa-solid fa-angle-up arrow-right" />
            ) : (
              <i className="fa fa-solid fa-angle-right arrow-right" />
            )}
          </div>
        </div>
        {isActive && (
          <div className="accordion-content">
            <span className="item description">{challenge.description}</span>
          </div>
        )}
      </div>
    </Fragment>
  );
};

export default ChallengeSectionRow;
